import React from "react";
import Layout from "../../layouts/index";
import ProofOfWorkEligibilityScreen from "../../screens/onbording/ProofOfWorkEligibility";

const ProofOfWorkEligibility = () => {
  return (
    <Layout hideHeader={true} hideFooter={true}>
      <ProofOfWorkEligibilityScreen />
    </Layout>
  );
};

export default ProofOfWorkEligibility;
